export default "__VITE_ASSET__Baulr476__"